import { FieldDropdown } from 'shared/ui'
import { BroadcastAssigneeDropdownContent } from '../BroadcastAssigneeDropdown/BroadcastAssigneeDropdownContent'
import { BroadcastAssigneeDropdownTrigger } from '../BroadcastAssigneeDropdown/BroadcastAssigneeDropdownTrigger'

export const BroadcastAssigneeField = () => {
  return (
    <FieldDropdown
      labelText={'Assignee'}
      placement={'bottom'}
      customTriggerComponent={() => <BroadcastAssigneeDropdownTrigger />}
      customComponent={(onCloseMenu) => (
        <BroadcastAssigneeDropdownContent onCloseMenu={onCloseMenu} />
      )}
    />
  )
}
